import { useEffect, useMemo, useState } from 'react';
import type { TTransportSubtype } from 'api/swagger';
import type { IUseGetTransportTypesProps, IUseGetTransportTypesResult } from 'components/trips/trip-form/types';
import { getTrailerSubTypesByTrain } from './helpers';

export const useGetTransportTypes = ({
  truckId,
  trucks = [],
  onChange,
}: IUseGetTransportTypesProps): IUseGetTransportTypesResult => {
  const [prevTruckSubType, setPrevTruckSubType] = useState<TTransportSubtype | undefined>(undefined);

  const truckSubType = useMemo((): TTransportSubtype | undefined => {
    const selectedTruck = trucks.find((truck) => truck.id === truckId);

    if (selectedTruck) {
      return selectedTruck?.subType;
    }
  }, [truckId, trucks]);

  const trailerSubTypes = useMemo(() => getTrailerSubTypesByTrain(truckSubType), [truckSubType]);

  useEffect(() => {
    const isChange = prevTruckSubType && truckSubType !== prevTruckSubType;
    setPrevTruckSubType(truckSubType);

    if (isChange) {
      onChange?.(truckSubType);
    }
  }, [truckSubType, prevTruckSubType]);

  return { truckSubType, trailerSubTypes };
};
